import { render } from "./LbrxLanguageSelectPopup.vue?vue&type=template&id=3df022d5&scoped=true"
import script from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"
export * from "./LbrxLanguageSelectPopup.vue?vue&type=script&lang=js"

import "./LbrxLanguageSelectPopup.vue?vue&type=style&index=0&id=3df022d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df022d5"]])

export default __exports__